import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'loyalty-exception',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const loyaltyException = require('./LoyaltyException').default
        cb(null, loyaltyException)
      }, 'LoyaltyException')
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/LoyaltyException/index.js